import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { RoleBreadcrumb, RoleItemWidget } from '@/widgets/role-item-widget'

export const Route = createFileRoute('/_auth/users/update-role/$roleId')({
  staticData: {
    meta: {
      title: 'Редактирование роли',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper title={t('Редактирование роли')} breadcrumbs={<RoleBreadcrumb />}>
      <RoleItemWidget mode="edit" />
    </PageWrapper>
  )
}
